var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4C9.21442 4 7.95772 4.38122 6.8888 5.09545C5.81988 5.80968 4.98676 6.82484 4.49479 8.01256C4.00282 9.20028 3.87409 10.5072 4.1249 11.7681C4.3757 13.029 4.99477 14.1872 5.90381 15.0962C6.81285 16.0052 7.97104 16.6243 9.23192 16.8751C10.4928 17.1259 11.7997 16.9972 12.9874 16.5052C14.1752 16.0132 15.1903 15.1801 15.9046 14.1112C16.6188 13.0423 17 11.7856 17 10.5C16.9999 8.77613 16.315 7.12289 15.0961 5.90393C13.8771 4.68496 12.2239 4.00011 10.5 4V4Z",
    stroke: "#7F82A2",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.5L19 19",
    stroke: "#7F82A2",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch24);
export default __webpack_public_path__ + "static/media/search24.f7aaaa431a4dfbc047f20786ac587b22.svg";
export { ForwardRef as ReactComponent };